import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import CustomGenericTittleIcon from "../../../../../../../components/CustomGenericTittleIconDataChip";
import RulesTable from "../../Global/CreateUpdatePolicy/SubComponents/RulesTable";
import {
    GetPayrollPolicyByGroupId,
    UpdateStatusPayrollPolicy
} from "../../../../../../../reduxToolkit/PayrollPolicy/PayrollPolicyApi";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import {errorMsg} from "../../../../../../../Apis/functions";
import {toast} from "react-toastify";
import ConfirmModal from "../../../../../Visitor/Invitation/Modal/ConfirmModal";
import {IconUserClipboard} from "../../../../../../../components/buttons/IconButtons";
import {RULE_MODEL} from "../../Global/CreateUpdatePolicy/Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const RenderExpandedRow = ({ row, refreshRef, setModified, canUpdate }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [rules, setRules] = useState([]);
    const [selectedRule, setSelectedRule] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    /**
     * Fetches the rules belonging to the expanded policy group and updates local state.
     */
    const getData = () => {
        if (!row?.id) return;
        dispatch(GetPayrollPolicyByGroupId(row.id)).then(({ payload: { data: { data, success } } }) => {
            if (success === true) setRules(data?.map(e => RULE_MODEL.set(e)));
        });
    };

    /**
     * Keeps refreshRef always pointing to the latest getData so the parent can
     * trigger a re-fetch without causing a stale closure.
     */
    useEffect(() => {
        if (refreshRef) refreshRef.current = getData;
    });

    /**
     * Loads rules when the expanded row mounts or the target row changes.
     */
    useEffect(() => {
        getData();
    }, [row?.id]);

    /**
     * Toggles the active/inactive status of the selected rule and notifies the
     * parent table to refresh its data.
     */
    const handleStatusChange = () => {
        const isActive = selectedRule?.statusId === STATUS_MODEL.ACTIVE_COMPANY;
        const statusId = isActive ? STATUS_MODEL.IN_ACTIVE_COMPANY : STATUS_MODEL.ACTIVE_COMPANY;
        const successMsg = isActive ? 'has_been_deactivate_successfully' : 'has_been_activate_successfully';

        dispatch(UpdateStatusPayrollPolicy({ id: selectedRule.id, statusId })).then(
            ({ payload: { data: { success, code } } }) => {
                setShowConfirmModal(false);
                if (success === true) {
                    toast.success(t(successMsg));
                    setModified(true);
                } else {
                    errorMsg(code);
                }
                setSelectedRule(null);
            }
        );
    };

    return (
        <>
            <div className={"col-12"}>
                <CustomGenericTittleIcon Icon={IconUserClipboard} title={"rules"}/>
            </div>
            <div className={'col-12'}>
                <RulesTable
                    rules={rules}
                    isGlobal={false}
                    showStatus={true}
                    onStatusChange={canUpdate
                        ? (rule) => {
                            setSelectedRule(rule);
                            setShowConfirmModal(true);
                        } : undefined
                    }
                />
            </div>

            <ConfirmModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onClickFn={handleStatusChange}
                title_modal={parseInt(selectedRule?.statusId) === STATUS_MODEL.ACTIVE_COMPANY ? 'deactivate_policy' : 'activate_policy'}
                description={parseInt(selectedRule?.statusId) === STATUS_MODEL.ACTIVE_COMPANY
                    ? t('are_you_sure_you_want_to_deactivate_the_policy')
                    : t('are_you_sure_you_want_to_activate_the_policy')}
            />
        </>
    );
};

export default RenderExpandedRow;
